import {
  Box,
  Checkbox,
  Flex,
  FlexAnchor,
  List,
  ListItem,
  mdBumps,
  Notification,
  smBumps,
  Typo,
} from '@wrisk/ui-components'
import React, { Fragment, FunctionComponent } from 'react'

import { HelpLink } from '../../organisms/links'
import { WriskTrans } from '../../organisms/trans'
import { FormInputProps } from '../types'

export const CheckboxEligibilityFormInput: FunctionComponent<FormInputProps<boolean>> = ({
  value,
  onChange,
  name,
  t,
  tKey,
  tName,
}) => {
  const id = `${name}-check`

  const consentItems = t(tKey(tName, 'items'), {
    returnObjects: true,
    defaultValue: [],
  }) as string[]

  const link = t(tKey(tName, 'link'), { defaultValue: null })
  const linkText = t(tKey(tName, 'link-label'), { defaultValue: null })

  const helpLink =
    link && linkText ? (
      <HelpLink linkText={linkText} link={link} isOpenModal={true} />
    ) : null

  return (
    <Flex flexDirection='column' alignItems='flex-start' gap={mdBumps}>
      {consentItems.length ? (
        <Notification
          type='standalone'
          flexDirection='column'
          justifyContent='flex-start'
          alignItems='flex-start'
          gap={smBumps}
        >
          <List>
            {consentItems.map((item, i) => (
              <ListItem key={i} variant='bullet'>
                {item}
              </ListItem>
            ))}
          </List>
          {helpLink}
        </Notification>
      ) : null}
      <Box variant='raised' p={2} width={1}>
        <FlexAnchor
          as='label'
          variant='highlight'
          justifyContent='flex-start'
          alignItems='flex-start'
          htmlFor={id}
          width={1}
          p={4}
        >
          <Checkbox name={id} id={id} value={value} onChange={onChange} mr={4} />
          <Typo as='pre'>
            <WriskTrans
              t={t}
              i18nKey={tKey(tName, 'input-label')}
              components={{
                HelpLink: helpLink ?? <Fragment />,
              }}
            />
          </Typo>
        </FlexAnchor>
      </Box>
    </Flex>
  )
}
